import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";
import { BrowserRouter } from "react-router-dom";
import { msalInstance } from "./auth/msal";
import App from "./App";
import "./styles.css";
import "./arvetio-brand.css";

// Set the active account after login so the API client can acquire tokens silently.
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload && "account" in event.payload) {
    msalInstance.setActiveAccount((event.payload as { account: import("@azure/msal-browser").AccountInfo }).account);
  }
});

async function bootstrap() {
  await msalInstance.initialize();
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>,
  );
}

bootstrap();
